module.exports = __webpack_public_path__ + "static/food-drinks-2-68a511ef998d35d3541498fde0b017ef.jpg";